import type { RouteObject } from 'react-router'

import { routeCrumb } from '../client/components/Admin/TopNavBar/utils/routeCrumb.js'

export const appStoreRoutes: RouteObject = {
  path: 'app-store',
  async lazy() {
    const { AppStoreBreadCrumb } = await import(
      '../client/components/Admin/Store/StoreRoute.js'
    )
    const { RouteContainer } = await import(
      '../client/components/Container/RouteContainer.js'
    )

    return {
      Component: RouteContainer,
      handle: routeCrumb(AppStoreBreadCrumb),
    }
  },
  children: [
    {
      path: 'mcp',
      async lazy() {
        const { McpPage, McpPageBreadCrumb } = await import(
          '../client/components/Admin/Store/Mcp/McpPage.js'
        )

        return {
          Component: McpPage,
          handle: routeCrumb(McpPageBreadCrumb),
        }
      },
    },
    {
      path: ':category',
      async lazy() {
        const { StorePage, StorePageBreadCrumb } = await import(
          '../client/components/Admin/Store/StorePage.js'
        )

        return {
          Component: StorePage,
          handle: routeCrumb(StorePageBreadCrumb),
        }
      },
    },
    {
      async lazy() {
        const { AddonRoute, AddonBreadCrumb } = await import(
          '../client/components/Admin/Store/Addon/AddonRoute.js'
        )

        return {
          Component: AddonRoute,
          handle: routeCrumb(AddonBreadCrumb),
        }
      },
      children: [
        {
          path: 'addons/:addonId',
          async lazy() {
            const { StoreAddonPage, StoreAddonPageBreadCrumb } = await import(
              '../client/components/Admin/Store/Addon/StoreAddonPage.js'
            )

            return {
              Component: StoreAddonPage,
              handle: routeCrumb(StoreAddonPageBreadCrumb),
            }
          },
        },
      ],
    },
    {
      path: 'apps',
      async lazy() {
        const { AppsRoute, AppsBreadCrumb } = await import(
          '../client/components/Admin/Store/App/AppsRoute.js'
        )

        return {
          Component: AppsRoute,
          handle: routeCrumb(AppsBreadCrumb),
        }
      },
      children: [
        {
          path: ':appId',
          async lazy() {
            const { StoreAppPage, StoreAppPageBreadCrumb } = await import(
              '../client/components/Admin/Store/App/StoreAppPage.js'
            )

            return {
              Component: StoreAppPage,
              handle: routeCrumb(StoreAppPageBreadCrumb),
            }
          },
        },
      ],
    },
  ],
}
